import { render, staticRenderFns } from "./BattleCrew.vue?vue&type=template&id=847d056e&scoped=true"
import script from "./BattleCrew.vue?vue&type=script&lang=js"
export * from "./BattleCrew.vue?vue&type=script&lang=js"
import style0 from "./BattleCrew.vue?vue&type=style&index=0&id=847d056e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847d056e",
  null
  
)

export default component.exports